var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"lg-side"},[_c('keep-alive',[_c(_vm.currentView.tag,{tag:"component",attrs:{"data":_vm.currentView.data,"mailConfiguration":_vm.mailConfiguration},on:{"open-message":_vm.openMessage,"messages-updated":_vm.updateMessages}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }